import React, { Fragment } from 'react';

import {
	StyledInput,
	ValidateMsg,
} from './styled';


interface Props {
	value?: string,
	disabled?: boolean,
	placeholder: string,
	className: string,
	onChange: (value: string) => void,
}

export default class extends React.Component<Props> {
	onInputChange = (value: string) => {
		const { onChange } = this.props;
		if(value.length <= 30) {
			return onChange(value);
		}
	};

	render() {
		const {
			value = '',
			placeholder,
			className
		} = this.props;

		return (<Fragment>
			<StyledInput
				id='engraving-text-input'
				value={value}
				placeholder={placeholder}
				onChange={e => this.onInputChange(e.target.value)}
				className={className}
				style={{ textIndent: "10px" }}
			/>
			{
				value.length >= 30 && <ValidateMsg
					isError={true}
				>
					Max. 30
				</ValidateMsg>
			}			
		</Fragment>);
	}
}
